module.exports = __webpack_public_path__ + "img/tractor-grey.99f7d7a2.svg";